function initTeamLightbox() {
    const teamMembers = document.querySelectorAll('.js-team-member');
    const backdrop = document.querySelector('.js-lightbox-backdrop');

    if (backdrop) {
        backdrop.addEventListener('click', closeLightbox);
    }

    [...teamMembers].forEach(teamMember => {
        teamMember.addEventListener('click', () => openLightbox(teamMember), true);

        const closeButton = teamMember.querySelector('.js-team-lightbox-close');
        closeButton.addEventListener('click', closeLightbox, true);
    });

    function openLightbox(teamMember) {
        const lightbox = teamMember.querySelector('.js-team-lightbox');
        document.documentElement.classList.add('js-lightbox-open');
        document.body.classList.add('js-lightbox-open');
        lightbox.classList.add('js-team-lightbox--visible');
        backdrop.classList.add('js-lightbox-backdrop--visible');
    }

    function closeLightbox() {
        [...teamMembers].forEach(teamMember => {
            const lightbox = teamMember.querySelector('.js-team-lightbox');
            lightbox.classList.remove('js-team-lightbox--visible');
            backdrop.classList.remove('js-lightbox-backdrop--visible');
        });

        document.documentElement.classList.remove('js-lightbox-open');
        document.body.classList.remove('js-lightbox-open');
    }

    document.addEventListener('keydown', keyPress);

    function keyPress(e) {
        if (e.key === 'Escape') {
            closeLightbox();
        }
    }
}

initTeamLightbox();
